// All route paths in one place
export const all_routes = {
  // Auth routes
  login: "/login",
  twoStepVerification: "/two-step-verification",
  //Super Admint routes
  adminCompanies: "/admin/companies",

  // Admin routes
  adminDashboard: "/admin/dashboard",
  adminUsers: "/admin/users",
  adminGuestLinks: "/admin/guest-links",
  adminTestimonials: "/admin/testimonials",

  // User routes
  userDashboard: "/user/dashboard",
  userRecord: "/user/record",

  // Guest routes
  guestSubmit: "/guest-submit/qr/:token",

  // Public routes
  home: "/",
  unauthorized: "/unauthorized",
};
